import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeModule } from './pages/home/home.module';
import { HomeComponent } from './pages/home/home/home.component';
import { AboutUsModule } from './pages/about-us/about-us.module';
import { AboutUsComponent } from './pages/about-us/about-us/about-us.component';
import { ContactUsModule } from './pages/contact-us/contact-us.module';
import { ContactUsComponent } from './pages/contact-us/contact-us/contact-us.component';
import { ServicesModule } from './pages/services/services.module';
import { ServicesComponent } from './pages/services/services/services.component';
import { ConsultingModule } from './pages/services/consulting/consulting.module';
import { ConsultingComponent } from './pages/services/consulting/consulting/consulting.component';
import { AdvisoryComponent } from './pages/services/consulting/advisory/advisory.component';
import { ArchitectureComponent } from './pages/services/consulting/architecture/architecture.component';
import { ProjectComponent } from './pages/services/consulting/project/project.component';
import { CloudComponent } from './pages/services/cloud/cloud/cloud.component';
import { CloudBackupComponent } from './pages/services/cloud/cloud-backup/cloud-backup.component';
import { CloudHostingComponent } from './pages/services/cloud/cloud-hosting/cloud-hosting.component';
import { NetworkComponent } from './pages/services/managed/network/network.component';
import { SecurityComponent } from './pages/services/managed/security/security.component';
import { TechnicalComponent } from './pages/services/technical/technical/technical.component';
import { SupportComponent } from './pages/services/technical/support/support.component';
import { ProactiveComponent } from './pages/services/technical/proactive/proactive.component';
import { SoftwareDevelopmentComponent } from './pages/services/software-development/software-development/software-development.component';
import { DevopsComponent } from './pages/services/software-development/devops/devops.component';
import { BespokeComponent } from './pages/services/software-development/bespoke/bespoke.component';
import { QualityAssuaranceComponent } from './pages/services/software-development/quality-assuarance/quality-assuarance.component';
import { CloudModule } from './pages/services/cloud/cloud.module';
import { TechnicalModule } from './pages/services/technical/technical.module';
import { ManagedModule } from './pages/services/managed/managed.module';
import { SoftwareDevelopmentModule } from './pages/services/software-development/software-development.module';
import { ManagedComponent } from './pages/services/managed/managed/managed.component';
import { LegalComponent } from './shared/legal/legal.component';
import { SitemapComponent } from './shared/sitemap/sitemap.component';
import { PrivacyComponent } from './shared/privacy/privacy.component';
import { TermsOfUseComponent } from './shared/terms-of-use/terms-of-use.component';
import { Bitrix24Component } from '../app/pages/bitrix24/bitrix24.component';


const routes: Routes = [

  { path: '', component: HomeComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'services/consulting', component: ConsultingComponent },
  { path: 'services/consulting/advisory', component: AdvisoryComponent },
  { path: 'services/consulting/architecture', component: ArchitectureComponent },
  { path: 'services/consulting/pmo', component: ProjectComponent },
  { path: 'services/cloud', component: CloudComponent },
  { path: 'services/cloud/backup', component: CloudBackupComponent },
  { path: 'services/cloud/hosting', component: CloudHostingComponent },
  { path: 'services/managed', component: ManagedComponent },
  { path: 'services/managed/network', component: NetworkComponent },
  { path: 'services/managed/security', component: SecurityComponent },
  { path: 'services/technical', component: TechnicalComponent },
  { path: 'services/technical/general-support', component: SupportComponent },
  { path: 'services/technical/proactive-support', component: ProactiveComponent },
  { path: 'services/software', component: SoftwareDevelopmentComponent },
  { path: 'services/software/devops', component: DevopsComponent },
  { path: 'services/software/bespoke', component: BespokeComponent },
  { path: 'services/software/qa-and-testing', component: QualityAssuaranceComponent },
  { path: 'legal', component: LegalComponent },
  { path: 'site-map', component: SitemapComponent },
  { path: 'privacy-policy', component: PrivacyComponent },
  { path: 'terms-of-use', component: TermsOfUseComponent },
  { path: 'bitrix24', component: Bitrix24Component },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true}),
    HomeModule,
    AboutUsModule,
    ContactUsModule,
    ServicesModule,
    ConsultingModule,
    CloudModule,
    TechnicalModule,
    ManagedModule,
    SoftwareDevelopmentModule
    ],

  exports: [RouterModule]
})
export class AppRoutingModule { }
